export default "__VITE_ASSET__BO7DmdL0__"